/* eslint-disable no-unused-vars */
import React, {
  Component,
  useState,
  useRef,
  useEffect,
  useCallback,
  useContext,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import Body from './body/Body';
import BodyCheckboxes from './body/BodyCheckboxes';
import { NPS_SCORE_INTERSECTION } from '../../../app/constants';
import FreeHr from './body/free/FreeHr';
import FreeComment from './FreeComment';

const CheckBoxes = ({ inquiry, nps, inquiryNegative }) => {
  // console.log('BodyNode > CheckBoxes', inquiryNegative)
  return (
    inquiry.checkList.available && (
      <>
        <BodyCheckboxes
          options={
            nps.checked < NPS_SCORE_INTERSECTION &&
            inquiryNegative.checkList.available
              ? inquiryNegative.checkList.options
              : inquiry.checkList.options
          }
        />
        {/*
         border - checkbox 非表示のときにあわせて消える + free comment 有りの時に表示する
         */}
        {inquiry.freeInput.available && <FreeHr />}
      </>
    )
  );
};

const Comment = ({ inquiry, textareaRef }) => {
  return (
    inquiry.freeInput.available && (
      <FreeComment
        className={'Inquiry-FreeComment'}
        textareaRef={textareaRef}
        inquiry={inquiry}
      />
    )
  );
};

const BodyNode = ({
  scrollerRef,
  headerHeight,
  bodyPadding,
  inquiry,
  nps,
  inquiryNegative,
  textareaRef,
}) => {
  // console.log('BodyNode - inquiry', inquiry)
  return (
    <Body
      className={'Inquiry-Body'}
      headerHeight={headerHeight}
      ref={scrollerRef}
      padding={bodyPadding}
    >
      <CheckBoxes
        inquiry={inquiry}
        nps={nps}
        inquiryNegative={inquiryNegative}
      />
      {/* free comment */}
      <Comment inquiry={inquiry} textareaRef={textareaRef} />
    </Body>
  );
};

export default BodyNode;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/BodyNode.js